import React, { useState } from 'react';
import Prisijungimas from '../Components/Prisijungimas';
import Registracija from '../Components/Registracija';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { LoginTemplate } from '../Components/Templates/LoginTemplate';
import { Box, Tab, Tabs, Typography } from '@mui/material';

const TabPanel = ({ children, value, index }) =>  (
    <div
        role="tabpanel"
        hidden={value !== index}
        style={{ display: value !== index ? 'none' : 'block' }}
    >
        {value === index && children}
    </div>
)

const Main = () => {
    const { t } = useTranslation();
    const [params, set] = useSearchParams();
    const [registrated, setRegistrated] = useState(false);
    const [tab, setTab] = React.useState(Number(params.get('tab')) ?? 0);

    const handleChange = (_, newTab) => {
        setTab(newTab);
        set({});
    };

    return (
        <LoginTemplate
            title={
                <>
                <Typography
                    sx={{
                        py: 2,
                        textAlign: "center",
                        color: { xs: "common.white", sm: "primary.main" },
                        fontWeight: 700,
                        fontSize: "1.5em" 
                    }}
                >
                    {!registrated ? t('darbuotojų_apklausa') :  t('sekminga_reg')}
                </Typography>
                {registrated &&
                    <Typography
                        sx={{
                            color: { xs: "common.white", sm: "common.black"},
                            fontSize: "14px",
                            fontWeight: 400
                        }}
                    >
                        {t('sekminga_reg_txt1')}
                    </Typography>
                }
                </>
            }
        >
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs centered value={tab} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label={t("prisijungti")} />
                        <Tab label={t("registruotis")} />
                    </Tabs>
                </Box>
                <TabPanel value={tab} index={0}>
                    <Prisijungimas />
                </TabPanel>
                <TabPanel value={tab} index={1}>
                    <Registracija
                        setRegistrated={setRegistrated}
                        setTab={setTab}
                    />
                </TabPanel>
            </Box>
        </LoginTemplate>
    )
}

export default Main

